import React, { useState, useEffect, useRef, createRef } from "react";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import Joi from "joi-browser";
import Input from "../common/Input";
import Select from "../common/Select";
import Checkbox from "../common/Checkbox";
import {
  docusignAccess,
  sendTemplate,
  sendRecipientViewRequest,
  sendInPersonSigningRequest,
} from "../services/docusignService";

function DocusignModal({
  compositeTemplates,
  internalOptions,
  externalOptions,
  safyUsers,
  open,
  token,
  clearData,
}) {
  const [data, setData] = useState();
  const [isOpen, setIsOpen] = useState(open);
  const [errors, setErrors] = useState({});
  const user = localStorage.getItem("safyInfo")
    ? JSON.parse(localStorage.getItem("safyInfo")).user
    : "";

  useEffect(() => {
    const templateJSON = JSON.parse(JSON.stringify(compositeTemplates));
    setData(templateJSON);
  }, [isOpen === true]);

  const dsorg =
    process.env.REACT_APP_ENVIRONMENT === "Production"
      ? "https://app.docusign.com"
      : "https://apps-d.docusign.com/send";

  //   useEffect(() => {
  //     setData(null);
  //   }, [isOpen === false]);

  const RecipientSelect = (role, index) => {
    return (
      <div
        className="border m-2 px-2 bg-light"
        key={`${role.roleName}${index}`}
      >
        {role && role.required && (
          <div className="rounded bg-danger text-white my-2 p-2">Required</div>
        )}
        <Select
          key={`select${role.roleName}${index}`}
          className="ps-4 mb-2"
          label={`${index + 1}: ${role.roleName}${
            role.roleDescription ? "-" + role.roleDescription : ""
          }`}
          options={role.Type === "Internal" ? internalOptions : externalOptions}
          onChange={(e) => {
            handleChange(e, index, "");
          }}
          disabled={
            data.compositeTemplates[0].inlineTemplates[0].recipients.signers[
              index
            ].adhoc &&
            data.compositeTemplates[0].inlineTemplates[0].recipients.signers[
              index
            ].email
          }
        ></Select>
        {role.Type !== "Internal" ? (
          <div key={`${role.roleName}${index}`}>
            {data.compositeTemplates[0].inlineTemplates[0].recipients.signers[
              index
            ].adhoc && (
              <div className="px-4">
                <Input
                  name={`${role.roleName}${index}adhocName`}
                  label="or Ad-Hoc Full Name"
                  onChange={(e) => handleAdHocChange(e, index, "name")}
                ></Input>
              </div>
            )}
            <div className="px-4">
              <Input
                name={`${role.roleName}${index}adhocEmail`}
                label="Email"
                onChange={(e) =>
                  handleAdHocChange(e, index, "email", role.roleName)
                }
                value={role.email}
                error={errors[`${role.roleName}${index}adhocEmail`]}
              ></Input>
            </div>
            <div className="ms-4 ps-4">
              <Checkbox
                name={`InPerson${role.roleName}`}
                label="In Person Signing (use if individual doesn’t have email address)"
                checked={role.inPerson && role.inPerson === true ? true : false}
                onChange={() => {
                  const obj = { ...data };
                  const roles = [
                    ...obj.compositeTemplates[0].inlineTemplates[0].recipients
                      .signers,
                  ];
                  roles[index].inPerson =
                    roles[index].inPerson && roles[index].inPerson === true
                      ? false
                      : true;
                  if (roles[index].inPerson && roles[index].inPerson === true) {
                    roles[index].email = user.email;
                    if (!roles[index].name) {
                      roles[index].name = user.displayName;
                    }
                  }
                  obj.compositeTemplates[0].inlineTemplates[0].recipients.signers =
                    roles;
                  setData(obj);
                }}
                disabled={role.adhoc === false && role.email === user.email}
              ></Checkbox>
            </div>
          </div>
        ) : (
          <Select
            key={`safyselect${role.roleName}${index}`}
            className="ps-4 mb-2"
            label="or select from all SAFY users"
            options={safyUsers}
            onChange={(e) => {
              handleChange(e, index, "allSafy");
            }}
          ></Select>
        )}
      </div>
    );
  };

  const PopulateInputs = (role, index) => {
    return (
      <div key={`input${role.roleName}${index}`}>
        {role.tabs
          ? role.tabs.textTabs
            ? role.tabs.textTabs.map((textTab, tabIndex) =>
                textTab.ReadOnly ? (
                  <div
                    key={`${textTab.tabLabel}${tabIndex}`}
                    className="ms-4 mb-2"
                  >
                    {textTab.Name}:
                    <br />
                    {textTab.value}
                  </div>
                ) : (
                  <div className="ms-4" key={`${textTab.tabLabel}${tabIndex}`}>
                    <Input
                      className="ms-4"
                      label={`${textTab.Name}:`}
                      value={textTab.value ? textTab.value : ""}
                      onChange={(e) => {
                        handleTextTabChange(e, index, tabIndex);
                      }}
                    ></Input>
                  </div>
                )
              )
            : null
          : null}
      </div>
    );
  };

  const handleTextTabChange = (
    { currentTarget: input },
    templateRoleIndex,
    textTabIndex
  ) => {
    const obj = { ...data };

    obj.compositeTemplates[0].inlineTemplates[0].recipients.signers[
      templateRoleIndex
    ].tabs.textTabs[textTabIndex].value = input.value;

    setData(obj);
  };

  const handleChange = ({ currentTarget: input }, index, type) => {
    console.log("Docusign recipient index", index, input);
    const obj = { ...data };
    const roles = [
      ...obj.compositeTemplates[0].inlineTemplates[0].recipients.signers,
    ];

    const isInternal = roles[index].Type === "Internal";

    let optionType;

    switch (type) {
      case "allSafy":
        optionType = [...safyUsers];
        break;
      default:
        optionType = isInternal ? [...internalOptions] : [...externalOptions];
    }

    if (input.value !== "") {
      const ctOption = optionType[input.selectedIndex - 1];
      console.log("Selected User", ctOption);
      roles[index].email = input.value;
      roles[index].name = ctOption.name;
      roles[index].adhoc = false;

      console.log("In Person Check", isInternal, input.value, user.email);
      if (!isInternal && input.value === user.email) {
        roles[index].inPerson = true;
      }

      // if (isInternal && index === 0 && input.value === user.email)
      //   roles[index].clientUserId = 1337;
    } else {
      roles[index].name = "";
      roles[index].email = "";
      roles[index].adhoc = true;
      roles[index].inPerson = false;
    }

    if (type === "allSafy" && input.value !== "") {
      roles[index].adhoc = true;
    } else {
      roles[index].adhoc = false;
    }

    obj.compositeTemplates[0].inlineTemplates[0].recipients.signers = roles;

    setData(obj);
  };

  const handleAdHocChange = (
    { currentTarget: input },
    index,
    field,
    roleName
  ) => {
    console.log("Ad Hoc Change", index, field);
    const obj = { ...data };
    const roles = [
      ...obj.compositeTemplates[0].inlineTemplates[0].recipients.signers,
    ];
    if (input.value !== "") {
      roles[index][field] = input.value;
      roles[index].adhoc = true;
    }
    roles[index].inPerson = roles[index].email === user.email;
    obj.compositeTemplates[0].inlineTemplates[0].recipients.signers = roles;
    setData(obj);

    if (field === "email") {
      const objToValidate = { email: input.value };
      const schema = { email: Joi.string().email() };
      const { error } = Joi.validate(objToValidate, schema, { convert: true });

      const errs = { ...errors };

      if (error) {
        errs[`${roleName}${index}adhocEmail`] = "Email is invalid";
      } else delete errs[`${roleName}${index}adhocEmail`];

      setErrors(errs);
    }
  };

  const recipientCheck = () => {
    console.log("Recipient Check", data);
    let invalid = false;

    if (data) {
      const roles =
        data.compositeTemplates[0].inlineTemplates[0].recipients.signers;

      roles.forEach((role) => {
        console.log("Role Name:", role.name, "Email", role.email, role);
        if ((role.name !== undefined) & (role.name !== "")) {
          console.log("Role Name Exists");
          if (role.email === undefined) {
            console.log("Role email does not exist");
            invalid = true;
          }
        }
      });
    }

    return invalid;
  };

  const allRequiredSigners = (template) => {
    console.log("Template JSON", template);
    let allSigners = true;
    const signers =
      template.compositeTemplates[0].inlineTemplates[0].recipients.signers;
    console.log("Template Signers", signers);
    signers.forEach((signer) => {
      if (
        signer.required &&
        signer.required === true &&
        (signer.name === "" || signer.name === undefined)
      ) {
        allSigners = false;
        toast.error(`Signer "${signer.roleName}" is required`);
      }
    });
    return allSigners;
  };

  const sendToDocusign = async (template) => {
    if (user && allRequiredSigners(template) === true) {
      toast.success("Loading Docusign Window");
      console.log("Sending Docusign Template", template);
      const envelope = await sendTemplate(token, template);
      console.log("Docusign Envelope Response", envelope);

      if (envelope.envelopeId) {
        let inPersonSigners = [];
        template.compositeTemplates.forEach((compositeTemplate) => {
          compositeTemplate.inlineTemplates.forEach((inlineTemplate) => {
            inlineTemplate.recipients.signers.forEach((signer) => {
              if (signer.inPerson && signer.inPerson === true) {
                const inPersonJSON = {
                  hostEmail: inlineTemplate.recipients.signers[0].email,
                  hostName: inlineTemplate.recipients.signers[0].name,
                  inPersonSigningName: signer.name,
                  signerName: signer.name,
                  inPersonSigningType: "inPersonSigner",
                  recipientId: signer.recipientId,
                  roleName: signer.roleName,
                };
                inPersonSigners.push(inPersonJSON);
              }
            });
          });
        });

        if (inPersonSigners.length > 0) {
          const inPersonResponse = await sendInPersonSigningRequest(
            token,
            envelope.envelopeId,
            { inPersonSigners: inPersonSigners }
          );
          console.log("In Person Response", inPersonResponse);
        }

        if (
          template.compositeTemplates[0].inlineTemplates[0].recipients
            .signers[0].email &&
          template.compositeTemplates[0].inlineTemplates[0].recipients
            .signers[0].email === user.email
        ) {
          console.log(
            `${dsorg}/documents/details/${envelope.envelopeId.toLowerCase()}`
          );
          window.open(
            `${dsorg}/documents/details/${envelope.envelopeId.toLowerCase()}`
          );
        }

        //If first signer is logged in User
        // if (
        //   template.compositeTemplates[0].inlineTemplates[0].recipients
        //     .signers[0].email &&
        //   template.compositeTemplates[0].inlineTemplates[0].recipients
        //     .signers[0].email === user.email
        // ) {
        //   const recipientView = {
        //     returnUrl: ` ${
        //       window.location.host === "localhost:3000"
        //         ? "http://localhost:3000/dssuccess"
        //         : "https://safyportaltest.safy.org/dssuccess"
        //     }/dssuccess`,
        //     authenticationMethod: "Email",
        //     email:
        //       template.compositeTemplates[0].inlineTemplates[0].recipients
        //         .signers[0].email,
        //     userName:
        //       template.compositeTemplates[0].inlineTemplates[0].recipients
        //         .signers[0].name,
        //     clientUserId: 1337,
        //   };

        //   const recipient = await sendRecipientViewRequest(
        //     token,
        //     envelope,
        //     recipientView
        //   );
        //   console.log("Docusign Recipient View:", recipient);

        //   if (recipient.url)
        //     window.open(
        //       recipient.url,
        //       `${template.compositeTemplates[0].formName} Sign`
        //     );
        //   else alert(`Error: ${recipient.message}`);
        // } else alert("Docusign Email Sent"); //Replace with toast
      } else alert(`Error: ${envelope.message}`);
    }
    setData(undefined);
  };

  return (
    <Modal className="rounded" show={isOpen} animation={false}>
      <Modal.Header className="bg-safy3-1">
        <Modal.Title>
          {data && data.compositeTemplates[0].FormName}
          <div className="h6">
            {data && data.compositeTemplates[0].FormDescription}
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h5>Signers (in order)</h5>
        {data
          ? data.compositeTemplates[0].inlineTemplates[0].recipients.signers.map(
              (role, index) => RecipientSelect(role, index)
            )
          : null}
        <hr></hr>
        <h5>Prefilled Data</h5>
        {data
          ? data.compositeTemplates[0].inlineTemplates[0].recipients.signers.map(
              (role, index) => PopulateInputs(role, index)
            )
          : null}
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-danger"
          onClick={() => {
            setIsOpen(false);
            setData(null);
            clearData();
          }}
        >
          Cancel
        </button>
        <button
          className="btn btn-success"
          onClick={() => {
            if (
              Object.keys(errors).length === 0 &&
              allRequiredSigners(data) === true
            ) {
              sendToDocusign(data);
              setIsOpen(false);
              clearData();
            }
          }}
          disabled={recipientCheck()}
        >
          Submit
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default DocusignModal;
